import { Box } from '@mui/material';

import CreateAccountNavbar from './CreateAccountNavbar';

const DEFAULT_CONTENT_PB = 'calc(88px + env(safe-area-inset-bottom, 0px))';

export default function OnboardingPageLayout({
  children,
  footer,
  contentPb = DEFAULT_CONTENT_PB,
}) {
  return (
    <Box
      sx={{
        width: '100%',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100dvh',
        bgcolor: 'grey.100',
      }}
    >
      <CreateAccountNavbar />

      <Box
        sx={{
          flex: 1,
          maxWidth: { xs: '100%', sm: 480 },
          width: '100%',
          mx: 'auto',
          px: { xs: 2, sm: 3 },
          pt: 3,
          pb: footer ? contentPb : 4,
          boxSizing: 'border-box',
        }}
      >
        {children}
      </Box>

      {footer && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1100,
            bgcolor: 'background.paper',
            borderTop: '1px solid',
            borderColor: 'divider',
            px: 2,
            pt: 2,
            pb: 'max(20px, env(safe-area-inset-bottom, 20px))',
          }}
        >
          {footer}
        </Box>
      )}
    </Box>
  );
}
